<div class="recent-orders">
    <div class="title-buttons d-flex justify-content-between align-items-center">
        <strong>Sellers</strong>
    </div>
    
    <!-- Filter Section -->
    <div class="filter-section mb-3">
        <label class="me-2">Filter by Status:</label>
        <select class="form-select d-inline-block w-auto" [(ngModel)]="statusFilter" (change)="onStatusFilterChange($any($event.target).value)">
            <option value="ALL">All</option>
            <option value="PENDING">Pending</option>
            <option value="COMPLETED">Completed</option>
            <option value="VERIFIED">Verified</option>
            <option value="REJECTED">Rejected</option>
        </select>
    </div>
    
    <div class="table-responsive">
        <table class="table table-striped" id="sellers-table">
            <thead>
                <tr class="first last">
                    <th>Display Name</th>
                    <th>Seller Type</th>
                    <th>Status</th>
                    <th>Payment Method</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody *ngIf="loading">
                <tr>
                    <td colspan="5" style="text-align: center">Loading ...</td>
                </tr>
            </tbody>
            <tbody *ngIf="!loading && filteredSellers.length === 0">
                <tr>
                    <td colspan="5" style="text-align: center">No sellers found</td>
                </tr>
            </tbody>
            <tbody *ngIf="!loading && filteredSellers.length > 0">
                <tr *ngFor="let seller of filteredSellers | paginate: config">
                    <td>{{ getDisplayName(seller) }}</td>
                    <td>
                        <span class="badge" [ngClass]="seller.sellerType === 'company' ? 'bg-primary' : 'bg-secondary'">
                            {{ seller.sellerType === 'company' ? 'Company' : 'Private' }}
                        </span>
                    </td>
                    <td>
                        <span [ngClass]="getStatusClass(seller.status)">
                            {{ seller.status }}
                        </span>
                    </td>
                    <td>{{ getPaymentMethod(seller) }}</td>
                    <td>
                        <button class="btn btn-sm btn-outline-primary" (click)="viewSellerDetails(seller)">
                            View Details
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    
    <div class="toolbar" *ngIf="!loading && filteredSellers.length > 0">
        <div class="pager">
            <pagination-controls 
                class="pages" 
                maxSize="5" 
                previousLabel="Previous" 
                nextLabel="Next" 
                autoHide="true"
                id="sellers-listing" 
                (pageChange)="pageChange($event)">
            </pagination-controls>
        </div>
    </div>
</div>
